import api from "@/lib/api";

export function track(event, payload = {}) {
  return api.post("/analytics/events", { event, ...payload }).catch(() => null);
}
